import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { HelpersService } from '../../shared/helpers/helpers.service';
import { PermissionHelper, ComponentID, ActionType } from '../../shared/helpers/permissionshelper';
import { ApiService } from '../../shared/api-service/api.service';
import { AuthService } from '../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, NgForm } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { Logging } from '../../logging';
import { SearchService } from '../../shared/search/search.service';
import { Moment } from 'moment';
import { TransOtherDetailsComponent } from '../trans-other-details/trans-other-details.component';


const moment =  require('moment'); 



declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;

@Component({
  selector: 'app-trans-details',
  templateUrl: './trans-details.component.html',
  styleUrls: []
})
export class TransDetailsComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    setTimeout(() => {
     // this.openFirst();
    });
  }
 
  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private formBuilder: FormBuilder, 
    private permhelper:PermissionHelper,
    private route: ActivatedRoute,  private componentid : ComponentID ,
    private actiontype: ActionType,private searchService: SearchService ) { }


  apps: any[];
  currPage: number = 1;
  totalItems: number;
  itemsPerPage: number;
  loading: boolean = false;
  search_term: any = '';
  searchTerm$ = new Subject<string>();
  translist: any[];
  filterValues : any;
  exportdata: boolean = false;

  totalamount : number = 0;
  totalactualamount : number = 0;
  totalcharge : number = 0;

  selected: {startDate: Moment, endDate: Moment};
  displaytext : any = "Loading. Please wait...";

  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }
  mindate = moment("20160101");
  maxdate =  moment();


  ngOnInit() {
    
    this.getApps();

    this.getData(0);

    /*
    this.searchService.search(this.searchTerm$)
    .subscribe(results => {
       Logging.log('search triggered');
      this.search_term = results.trim();
      this.getData(0)
    });
    */

    const self = this;
    var timeout = null;
      $('#searchbox').on('keyup',function(e) {
        self.exportdata = false;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          self.search_term = $('#searchbox').val();
          self.getData(0)
      }, 2000);

      });

  }


  getApps(){
  
    this.loading = true;
    //window.scrollTo(0, 0);
    this.api.get('/campaigns/accounts/'+ this.auth.getAccountID() + '/apps' + '?sort=description,asc')
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.apps = res_data.data.content;
      this.loading = false;
      }, error_message => {
        this.loading = false;
      }
    );
  }

  onSubmit(form: NgForm)
  {
    this.exportdata = false;
     this.filterValues = JSON.parse(JSON.stringify(form.value));
    Logging.log(this.filterValues);
    //Logging.log(this.selected);
    this.getData(0);
  }

  export()
  {
      if(!this.filterValues || this.filterValues.selected.startDate == null)
      {
          const check = confirm("Are you sure you want to export all your data on REDDE?\nExport without date range filter might take a while.\nPlease confirm");
          if(!check)
          {
            return;
          }
        }
      
      this.exportdata = true;
      this.getData(0);
  }

  pagenateData(page:number)
  {
    this.exportdata = false;
    this.getData(page);
  }

   getData(page:number)
   {
    let filter : String = "";
     if(this.filterValues)
     {
        const appid = this.filterValues.appid;
        
        const from = (this.filterValues.selected.startDate == null)? "" :  moment(this.filterValues.selected.startDate).format('YYYY-MM-DD') ;
        const to = (this.filterValues.selected.endDate == null)? "" : moment(this.filterValues.selected.endDate).format('YYYY-MM-DD') ;
        const transtype = this.filterValues.transtype;

        Logging.log("appid=>"+ appid + ", from=>"+ from + ", to=>"+to+", transtype="+transtype);

      
        if(appid.length > 0)
        {
            filter = filter + "&campaignid="+appid;
        }
        if(from.length > 0 && to.length > 0)
        {
            filter = filter + "&from="+from + "&to="+to;
        }
        if(transtype.length > 0)
        {
            filter = filter + "&transtype="+transtype;
        }
     }

     if(this.exportdata)
     {
      filter = filter + "&export=true";
     }

    Logging.log("filter=> "+ filter);
        
      this.loading = true;
     // window.scrollTo(0, 0);
      //Fetch all users
      this.api.get('/accounts/'+ this.auth.getAccountID() + '/transactions' + '?sort=transactiondate,desc&search='+this.search_term+'&page=' + page  + filter)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.loading = false;
          if(this.exportdata)
          {
            this.helpers.flashSuccessCustom("Data export request sent. Download link will be sent to your email after processing",15000)
          }
          else
          {
            this.translist = res_data.data.content;
            this.totalItems = res_data.data.totalElements;
            this.itemsPerPage = res_data.data.size;
            this.currPage = res_data.data.number;

            this.totalamount = 0;
              this.totalactualamount = 0;
              this.totalcharge = 0;

            this.translist.forEach(t => {
              this.totalamount += Math.abs(t.amount);
              this.totalactualamount += Math.abs(t.actualamount);
              this.totalcharge += Math.abs(t.charge);
            });
          }
        
        }, error_message => {
          this.loading = false;
         //  this.hasError = true;
         //  this.errorMessage = error_message;
        }
      );
    }

    clearfilters()
    {
      $('#appid').val("").trigger("change");
      $('#transtype').val("").trigger("change");
      $('#daterange').val("").trigger("change");
      
    }

    clearDisplayText()
    {
      this. displaytext = "Loading. Please wait...";
    }

    openDetails(tid: any, channel: any, btransid: any)
    {
     
      this.loading = true;
      //window.scrollTo(0, 0);
      this.api.get('/accounts/'+ this.auth.getAccountID() + '/transactions/' + tid +'/otherdetails?channel='+channel)
      .subscribe(
        res_data => {
          const resp = res_data.data[0];
        Logging.log(res_data.data);
        this.loading = false;

        let html = "";
        resp['gateway Trans ID'] = btransid;
        for (let property in resp)
        {
          html = html + "<div class='row'><div class='col-md-6 form-group'><label><strong>" + property.toUpperCase().replace("QUEUE","")+ "<strong></label></div> "+
          "<div class='col-md-6 form-group'><label>" + resp[property] + "</label></div></div>";
            //Logging.log(property + " => "+ resp[property]);
        }

        $('#insidedetails').html(html);
        Logging.log("Adding now...");
        $("#mmdetails").modal({
          escapeClose: true,
          clickClose: false,
          showClose: false
        });

        }, error_message => {
          this.loading = false;
        }
      );

    }


    toAbs(amount : number) : number
    {
        return Math.abs(amount);
    }

   
    toFixed(amount:number, digit: number) : string
    {
      return amount.toFixed(digit);
    }


    
}



// WEBPACK FOOTER //
// ./src/app/client/trans-details/trans-details.component.ts